<template>
  <section class="breadcrumbs__container">
    <template v-for="(item, index) in breadcrumbs">
      <Link
        v-if="item.name"
        :key="toKebabCase(item.name)"
        class="breadcrumb"
        :to="{ name: item.name, params: { ...item.params } }"
      >
        {{ item.text }}

        <!-- Don't show separator after the last item -->
        <BreadCrumbSeparator v-if="index + 1 != breadcrumbs.length" />
      </Link>
      <h1 v-else :key="toKebabCase(item.text)" class="breadcrumb">{{ item.text }}</h1>
    </template>
  </section>
</template>

<script>
import BreadCrumbSeparator from '@/components/BreadCrumbs/BreadCrumbSeparator'
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'BreadCrumbs',
  components: {
    BreadCrumbSeparator,
  },
  props: {
    items: { type: Array },
    params: { type: Object },
  },
  mixins: [stringUtils],
  watch: {
    items(newItems) {
      this.breadcrumbs = newItems
    },
  },
  data() {
    return {
      breadcrumbs: this.items,
    }
  },
}
</script>

<style lang="scss" scoped>
.breadcrumbs__container {
  height: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;

  .breadcrumb {
    display: flex;
    align-items: center;
    color: var(--primary-font-color);
    font-size: 22px;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  a.breadcrumb:hover {
    opacity: 1;
    color: color-mix(in srgb, var(--primary-font-color) 80%, white);
  }

  h1.breadcrumb {
    margin: 0;
  }
}
</style>
